<template>
  <div>
    <div
      class="columns is-multiline"
      v-if="productsLoading || !products || products.length === 0"
    >
      <div
        v-for="p in [1, 2, 3, 4]"
        :key="p"
        class="column is-3-desktop is-4-tablet is-6-mobile"
      >
        <div class="card" style="height: 100%">
          <div class="card-content" style="height: calc(100% - 3rem - 1px)">
            <div class="media" style="height: 100%">
              <div
                style="height: 100%"
                class="
                  media-content
                  is-flex
                  is-justify-content-space-between
                  is-flex-direction-column
                "
              >
                <div class="title is-4 has-text-centered mb-6">
                  <b-skeleton size="is-large"></b-skeleton>
                  <div style="width: 50%; margin: auto" class="mt-2">
                    <a> <b-skeleton size="is-large"> </b-skeleton></a>
                  </div>
                </div>
                <p
                  class="
                    subtitle
                    is-6 is-flex is-align-items-center is-justify-content-center
                  "
                >
                  <a style="width: 40%"
                    ><b-skeleton width="100%" size="is-middle"> </b-skeleton
                  ></a>
                </p>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item">
              <a style="width: 50%"
                ><b-skeleton width="100%" size="is-middle"></b-skeleton
              ></a>
            </a>
          </footer>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-variable is-8">
      <div
        v-for="product in products"
        :key="product.name + product.id"
        class="column is-4-desktop is-6-tablet mb-5"
      >
        <div
          class="card product-overview-card is-flex is-flex-direction-column"
          style="height: 100%"
        >
          <div
            class="
              card-header
              is-align-items-center
              has-background-white
              px-3
              py-2
            "
          >
            <figure class="image is-32x32">
              <img src="../../assets/stamo-icon.png" />
            </figure>
            <div class="ml-2">
              <p
                class="has-text-black card-header-title p-0"
                style="margin-bottom: -4px"
              >
                STANDORTMONITOR.NET
              </p>
              <p class="has-text-grey is-size-7">
                {{ product.name }}
              </p>
            </div>
          </div>
          <div class="card-image">
            <figure class="image is-4by3">
              <img :src="product.image_url" :alt="product.name" />
              <div class="card-image-overlay">
                <b-button
                  v-if="isSubscribed(product.id)"
                  @click="changeSelectedProduct(product.id)"
                  size="is-medium"
                  class="cta-btn"
                >
                  Zum Produkt
                </b-button>
                <b-button
                  v-else
                  tag="a"
                  :href="`mailto:support@standortmonitor.net?subject=${encodeURI(
                    `Standormonitor ${product.name}`
                  )}`"
                  size="is-large"
                  class="cta-btn"
                  style="padding-top: 2.5rem; padding-bottom: 2.5rem"
                >
                  Kontaktieren <br />sie uns!
                </b-button>
              </div>
            </figure>
          </div>
          <div class="card-content mb-0 pl-0 pr-6">
            <div class="product-name">
              <p class="title is-5 px-5 is-uppercase">
                {{ product.name }}
              </p>
            </div>
          </div>
          <div class="card-content pt-0">
            <div class="product-description has-text-grey">
              <p v-if="product.description" style="line-height: initial">
                {{ product.description }}
              </p>
              <p v-else>Keine Beschreibung verfügbar.</p>
            </div>
          </div>
          <div class="card-footer margin-top-auto" style="border-top: 0">
            <p
              class="
                subtitle
                is-6
                is-italic
                is-flex
                is-align-items-center
                is-justify-content-space-between
                pl-5
                pr-3
                py-3
              "
              style="width: 100%"
            >
              <b>{{
                isSubscribed(product.id)
                  ? "Sie haben das Produkt abonniert!"
                  : "Produkt ist noch nicht abonniert."
              }}</b>
              <b-icon
                pack="fas"
                :icon="isSubscribed(product.id) ? 'check' : 'times'"
                size="is-small"
                :type="isSubscribed(product.id) ? 'is-success' : 'is-danger'"
                class="mr-1"
              ></b-icon>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductCardList',
  computed: {
    ...mapGetters({
      products: 'product/data',
      productById: 'product/dataById',
      productNavFlat: 'product/navFlat/dataByParentId',
      orgMe: 'org/me',
      orgProducts: 'org/product/dataByParentId',
      productsLoading: 'product/loading',
    }),
    enabledProducts() {
      return this.products.filter((product) => product.enabled);
    },
  },
  methods: {
    changeSelectedProduct(productId) {
      this.$store.commit('menu/SET_SELECTED_PRODUCT', productId);

      const route = this.productNavFlat(productId)[0];
      this.$router.push({
        name: 'View',
        params: {
          productId: parseInt(productId, 10),
          routeId: route.id,
          productName: this.convertRouteName(this.productById(productId).name),
          routeName: this.convertRouteName(route.name),
        },
      });
    },
    convertRouteName(plain) {
      return plain
        .replace(/\s/g, '-')
        .replace(/[^\w-]/g, '')
        .replace(/-+/g, '-');
    },
    isSubscribed(productId) {
      return (
        this.orgProducts(this.orgMe.id).length
        && this.orgProducts(this.orgMe.id).indexOf(productId) > -1
      );
    },
  },
};
</script>
<style>
.product-overview-card .card-image-overlay {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.product-overview-card .cta-btn {
  background-color: #ac8856;
  border: 2px solid white;
  color: white;
  text-transform: uppercase;
}
.product-overview-card .cta-btn:hover {
  background-color: white;
  color: #ac8856;
}
.product-overview-card .product-name {
  height: 45px;
  padding-bottom: 45px;
  border-bottom: 5px solid black;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.product-overview-card .product-description {
  max-height: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
